import {SsoAuditRecord} from 'src/openapi/admin/models/SsoAuditRecord';

export function formatInitiator(entry: SsoAuditRecord): string {
    if (entry.initiatorUser != null) {
        const {firstName, lastName, email} = entry.initiatorUser;
        const name = [firstName, lastName].filter(Boolean).join(' ').trim();
        return name || email || `User ${entry.initiatorUser.userId}`;
    }
    if (entry.initiatorSystem != null) {
        return entry.initiatorSystemProcess != null
            ? `${entry.initiatorSystem} / ${entry.initiatorSystemProcess}`
            : entry.initiatorSystem;
    }
    return '--';
}
